<div class="background-container {{ cssClass }}">
  <div class="icons">
    <div class="icon" [inlineSVG]="'/assets/backgrounds/fire-lightning/electric-circle.svg'"></div>
    <div class="icon" [inlineSVG]="'/assets/backgrounds/fire-lightning/fire-circle.svg'"></div>
  </div>
</div>

<ng-content></ng-content>
